import { Component, OnInit, OnChanges, Input, AfterViewInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DateTimeService } from '../../shared/datetime/datetime.service';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { MessageCancellationService } from '../services/messagecancellation.service';
import { CancelledMessageCorrelation } from '../models/cancelled-message-correlation';
import { TrackingService } from '../services/tracking.service';
import { Router } from '@angular/router';
import { GenericModalService } from 'src/app/shared/generic-modal/generic-modal.service';
import { BizDataGridDirective } from 'src/app/shared/grid/biz-grid.directive';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective as BizDataGridDirective_1 } from '../../shared/grid/biz-grid.directive';
import { DxoMasterDetailModule, DxiColumnModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { CancelMessageStatusDeatilsComponent } from './tracking-cancelled-messages-details.component';


@Component({
    selector: 'ep-tracking-cancelled-messages',
    templateUrl: './tracking-cancelled-messages.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, DxDataGridModule, BizDataGridDirective_1, DxoMasterDetailModule, DxiColumnModule, DxiButtonModule, DxTemplateModule, CancelMessageStatusDeatilsComponent]
})

export class CancelMessageStatusComponent implements OnInit, AfterViewInit {

    constructor(
        public dateTimeService: DateTimeService,
        private loadingPanelService: LoadingPanelService,
        private messageCancellationService: MessageCancellationService,
        private modalService: GenericModalService,
        private router: Router) {
    }

    @ViewChild(BizDataGridDirective, { static: true }) private datagrid: BizDataGridDirective;
    @Input() dataSourceItems: CancelledMessageCorrelation[] = [];
    selectedDataSourceItems: CancelledMessageCorrelation[] = [];

    ngAfterViewInit(): void {
        this.datagrid.rowDoubleClick.subscribe(row => {
            this.showDocuments(row.CorrelationId);
        });
    }

    ngOnInit(): void {
        this.refresh();
    }

    selectionChanged(e: any) {
        this.selectedDataSourceItems = e.selectedRowsData;
    }

    refresh() {
        this.loadingPanelService.showLoadingPanelDirect('Loading cencelled messages...');
        this.messageCancellationService.getCorrelations().then((result) => {
            if (result) {
                this.dataSourceItems = result;
                this.loadingPanelService.hideLoadingPanel();
            }
            else {
                 this.loadingPanelService.hideLoadingPanel();
            }
        }).catch(() => { this.loadingPanelService.hideLoadingPanel(); });
    }

    showCorrelations() {
        if (this.selectedDataSourceItems.length > 0)
        {
            const cid = this.selectedDataSourceItems[0].CorrelationId;
            this.showDocuments(cid);
        }
    }

    showCorrelation=(e)=> {
            const cid = e.row.data.CorrelationId;
            this.showDocuments(cid);
    };

    showDocuments(correlationId: string) {
        this.messageCancellationService.getCancellationDetails(correlationId).then((result) => {
            if (result) {
                const documentIds = result.DocumentIds;
                const interchangeInIds = result.InterchangeInIds;
                const interchangeOutIds = result.InterchangeOutIds;

                if (documentIds.length > 0 || interchangeInIds.length > 0) {

                    if ((documentIds.length + interchangeInIds.length) > TrackingService.maxNumberOfDocumentsToShow) {
                        const maxDocuments = TrackingService.maxNumberOfDocumentsToShow;
                        this.modalService.messageDirect('Maximum number of documents', `Maximum number of documents to show is ${maxDocuments}`);
                    }
                    else {
                        const searchIdObject = {};
                        if (documentIds.length > 0) {
                            searchIdObject['documentIds'] = documentIds.join(',');
                        }
                        if (interchangeInIds.length > 0) {
                            searchIdObject['interchangeInIds'] = interchangeInIds.join(',');
                        }
                        this.router.navigate(['tracking/result/details', searchIdObject]);
                    }
                }
            }
        });
    }
}
